export enum UserType{
    SuperUser,
    AdminUser,
    NormalUser
}